<template>
  <div>
    <app-form
      v-bind:parentObject="{
        pageTitle: this.pageTitle,
      }"
    />
  </div>
</template>

<script>
import Form from "../../../components/attendance/generatepatternroster/Form";

export default {
  components: {
    "app-form": Form,
  },

  data() {
    return {
      pageTitle: this.$t('generatepatternrosterrecord.generatepatternroster'),
    };
  },
};
</script>
